// Styles
import './VTimeline.sass'

// Types
import { VNode } from 'vue'
import mixins from '../../util/mixins'

// Mixins
import Themeable from '../../mixins/themeable'

export default mixins(
  Themeable
/* @vue/component */
).extend({
  name: 'v-timeline',

  provide (): object {
    return { timeline: this }
  },

  props: {
    alignTop: Boolean,
    dense: Boolean,
    reverse: Boolean,
    classPrefix: {
      type: String,
      default: '',
    },
  },

  computed: {
    classes (): {} {
      return {
        [`${this.classPrefix}v-timeline--align-top`]: this.alignTop,
        [`${this.classPrefix}v-timeline--dense`]: this.dense,
        [`${this.classPrefix}v-timeline--reverse`]: this.reverse,
        ...this.themeClasses,
      }
    },
  },

  render (h): VNode {
    return h('div', {
      staticClass: `${this.classPrefix}v-timeline`,
      class: this.classes,
    }, this.$slots.default)
  },
})
